import { render, staticRenderFns } from "./AffiliateDetails.vue?vue&type=template&id=562bc210&scoped=true&"
import script from "./AffiliateDetails.vue?vue&type=script&lang=js&"
export * from "./AffiliateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562bc210",
  null
  
)

export default component.exports